module.exports = __webpack_public_path__ + "static/media/certifikedu.97972cde.svg";